import { Pipe, PipeTransform } from '@angular/core';
import { HtmlFragmentPipe } from 'shared/components/canned-message-panel/filters/html-fragment';

@Pipe({
  name: 'appInnerText',
  pure: true
})
export class InnerTextPipe extends HtmlFragmentPipe implements PipeTransform {
  constructor() { super(); }

  transform(str: string) : string {
    this.fragment.innerHTML = str;
    return this.fragment.textContent || this.fragment.innerText || '';
  }
}
